import React, { useEffect, useState } from "react";
import "../../css/ProductListed.css";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { deleteObject, ref as sRef, getStorage } from "firebase/storage";
import { getDatabase, ref, set, onValue, remove } from "firebase/database";
import LoaderComponent from "../../component/LoaderComponent";
import { useAdminAuth } from "../../component/AdminUserPresent";

const ProductListed = () => {
	const [allProduct, setAllProduct] = useState([]);
	const [loader, setLoader] = useState(false);
	const [searchText, setSearchText] = useState("");
	const [fliterOrders, setFliterOrders] = useState([]);
	const db = getDatabase();
	const storage = getStorage();
	const navigate = useNavigate();
	const isAdmin = useAdminAuth();

	useEffect(() => {
		if (!isAdmin) return;
		const userRef = ref(db, "productDetails");
		onValue(userRef, (snapshot) => {
			const data = snapshot.val();
			if (!data) {
				setLoader(false);	
				return;
			}

			const products = Object.values(data) // categories
				.flatMap((category) => Object.values(category)); // products

			setAllProduct(products);
		setLoader(false);
		});
	}, [db]);

	useEffect(() => {
		const delay = setTimeout(() => {
			const text = searchText.trim().toLowerCase();

			if (text.length < 3) {
				setFliterOrders([]);
				return;
			}
			const filtered = allProduct.filter(
				(item) =>
					item?.productTitle
						?.toLowerCase()
						.includes(text.toLowerCase()) ||
					item?.productCategory
						?.toLowerCase()
						.includes(text.toLowerCase()) ||
					item?.productId?.toLowerCase().includes(text.toLowerCase()),
			);
			setFliterOrders(filtered);
			setLoader(false);
		}, 300);

		return () => clearTimeout(delay);
	}, [searchText, allProduct]);

	const handleDeleteProduct = async (product) => {
		const confirmDelete = window.confirm(
			"Are you sure you want to delete this product?",
		);
		if (!confirmDelete) return;
		try {
			setLoader(true);
			// 1️⃣ Delete all images from Firebase Storage
			if (product.postImageArray && product.postImageArray.length > 0) {
				await Promise.all(
					product.postImageArray.map(async (img) => {
						if (!img.url) return;

						const imageRef = sRef(storage, img.url);
						await deleteObject(imageRef);
					}),
				);
			}

			// 2️⃣ Delete product data from Realtime Database
			await remove(
				ref(
					db,
					`/productDetails/${product.productCategory}/${product.productId}`,
				),
			);

			toast.success("Product deleted successfully!");
		} catch (error) {
			console.error("Delete failed:", error);
			toast.error("Failed to delete product.");
		} finally {
			setLoader(false);
		}
	};

	const allProductItem =
		fliterOrders && fliterOrders.length > 0 ? fliterOrders : allProduct;

	return (
		<div>
			<ToastContainer />
			<div className="text-center pt-5 pb-4 product-listed-header">
				Product Listed
			</div>
			<div>
				<div className="d-flex justify-content-around flex-wrap mt-4 mb-5">
					<div className="d-flex justify-content-center py-2">
						<input
							type="text"
							name="text"
							id="searchtest"
							placeholder="Product title or category"
							className="py-1 px-3 search-input"
							value={searchText}
							onChange={(e) => setSearchText(e.target.value)}
							required
						/>
						<div className="pl-3">
							<button className="search-btn-buying-screen">
								Search
							</button>
						</div>
					</div>
					<div className="d-flex add-view-cat-product px-3">
						<div className="py-2 mr-4">
							<button
								className="add-category-card-btn"
								onClick={() => navigate("/categories")}
							>
								View category
							</button>
						</div>
						<div className="py-2">
							<button
								className="create-product-card-btn"
								onClick={() => {
									navigate("/productcreateview");
								}}
							>
								Create product
							</button>
						</div>
					</div>
				</div>
				<div className="product-list-view container">
					<div className="table-wrapper">
						<table className="admin-table">
							<thead>
								<tr className="table-heading">
									<th>#</th>
									<th>Image</th>
									<th>Product Title</th>
									<th>Category</th>
									<th>Product Id</th>
									<th>Actions</th>
								</tr>
							</thead>
							<tbody>
								{allProductItem.length === 0 ? (
									<tr>
										<td colSpan="6" className="no-data">
											No products found
										</td>
										<td>
											{loader && <LoaderComponent />}
										</td>
									</tr>
								) : (
									allProductItem.map((item, index) => (
										<tr key={item.productId}>
											<td>{index + 1}</td>
											<td>
												<img
													src={
														item.postImageArray?.[0]
															?.url
													}
													alt={item.productTitle}
													className="product-thumb"
												/>
											</td>
											<td>{item.productTitle}</td>
											<td className="description">
												{item.productCategory}
											</td>
											<td>{item.productId}</td>
											<td className="text-center">
												<button
													className="btn edit-btn mb-2"
													onClick={() => {
														navigate(
															`/product-edit/${item.productCategory}/${item.productId}`,
														);
													}}
												>
													Edit
												</button>

												<button
													className="btn delete-btn mb-2"
													onClick={() =>
														handleDeleteProduct(
															item,
														)
													}
												>
													Delete
												</button>
											</td>
										</tr>
									))
								)}
							</tbody>
						</table>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ProductListed;
